import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SimcardInterface, Tarif } from '../../../interfaces/Simcard';
import TarifSelect from '../../../organisms/simcards/TarifSelect';
import { TarifService } from '../../../services/simcards/Tarifs';
import { ActionsService } from '../../../services/tickets/Actions';
import { patchSimcard } from '../../../state/simdata/SimcardsSlice';
import { RootState } from '../../../state/store';
import { addToast } from '../../../state/toast/ToastSlice';
import LoadingSpinner from '../../buttons/LoadingSpinner';
import { SimStatusTag } from '../../tags/StatusTag';
import Typography from '../../typography/Typography';
import Form from '../Form';

type props = {
  currentTarifId: number;
  currentValue: string;
  simData: SimcardInterface;
  setSim: any;
};

const ChangeTarif: FC<props> = ({
  currentTarifId,
  currentValue,
  simData,
  setSim,
}) => {
  const [tarif, setTarif] = useState(currentTarifId);
  const [loading, setLoading] = useState(false);
  const [tarifs, setTarifs] = useState<Tarif[]>([]);
  const [disableButton, setDisableButton] = useState(false);

  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const actionsService = new ActionsService();
  const service = new TarifService();
  const tarifService = new TarifService();
  const dispatch = useDispatch();

  const handleChange = async (value, option) => {
    setTarif(value);
  };

  const fetchTarifs = async () => {
    const companyVoiceTarifs = await tarifService.getCompanySpecif(
      companyId!,
      'Voice'
    );
    const { result: companyDataTarifs } =
      await tarifService.getTarrisFromCompanyContract(companyId!, 'Data');

    const filteredDataTarifs = companyDataTarifs.filter(
      (tarif: Tarif) => tarif.trf_is_option !== 1
    );

    setTarifs({
      Voice: companyVoiceTarifs,
      Data: filteredDataTarifs,
    });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);

    const selectedTarif = await service.getTarif(tarif, companyId);
    const prop = {
      tariefplan: selectedTarif,
      trf_id: currentTarifId,
      sim_isActive: SimStatusTag.REQUEST_TARIFF,
    };

    setSim((state: SimcardInterface) => ({
      ...state,
      ...prop,
    }));

    dispatch(patchSimcard({ props: prop, simId: simData.sim_id }));
    await actionsService.changeTarif(companyId!, simData.sim_id, tarif);

    dispatch(
      addToast({
        description: 'Ticket aangemaakt',
        position: 'bottomRight',
        style: 'success',
      })
    );

    setDisableButton(true);
    setTimeout(() => {
      setDisableButton(false);
    }, 1000 * 60);
    setLoading(false);
  };

  useEffect(() => {
    fetchTarifs();
  }, []);

  return (
    <div>
      <Form
        buttonLabel="Indienen"
        handleSubmit={handleSubmit}
        gridSize="grid-cols-2"
        loading={loading}
        disable={disableButton}
      >
        <Typography tag="label" type="label">
          Selecteer nieuw tariefplan
        </Typography>
        {tarifs.length < 0 ? (
          <LoadingSpinner />
        ) : (
          <TarifSelect
            onSelect={(value) => handleChange(value, 'simTarifId')}
            defaultValue={currentValue}
            tarifs={tarifs}
            detail={true}
          />
        )}
      </Form>
    </div>
  );
};

export default ChangeTarif;
